module.exports = "<h2 class=\"gw-titles-subtitle\" ng-class=\"{ 'gw-titles-subtitle_offset': hasOffset }\">\r\n    <ng-transclude></ng-transclude>\r\n</h2>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/titles/templates/Subtitle.html
// module id = 606
// module chunks = 0